import store from '../store'

export function updateIssuePanelVisibility(docId,isVisible,projectId,userId) {	
	store.dispatch({ type:'UPDATE_ISSUE_PANEL_VISIBILITY',docId,isVisible,projectId,userId})
}



